const configs = {
    firebase: {
        apiKey: "AIzaSyCj8HY7aLzT_FhIPZexYIQMLtFCDx4U-2Y",
        authDomain: "abdi-social.firebaseapp.com",
        databaseURL: "https://abdi-social-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "abdi-social",
        storageBucket: "abdi-social.appspot.com",
        messagingSenderId: "388378346080",
        appId: "1:388378346080:web:4efbe8b31543f75193f905",
        measurementId: "G-Q76JCV5QLX"
    }
}

module.exports = configs;